<footer class="vc-admin-form-actions">
  @if (showCancel) {
    <button
      pButton
      type="button"
      class="p-button-outlined"
      [label]="secondaryLabelKey | translate"
      (click)="cancel.emit()"
      [disabled]="submitting"
    ></button>
  }

  <button
    pButton
    type="submit"
    [label]="(submitting ? submittingLabelKey : primaryLabelKey) | translate"
    [loading]="submitting"
    [disabled]="disablePrimary || submitting"
  ></button>
</footer>
